// @core/api/endpoints/analytics/share_dashboard.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DashboardResponse,
  ShareDashboardRequest,
} from '../../../types/analytics';

const BASE_PATH = '/analytics';

/**
 * Share dashboard
 * Updates the visibility of a dashboard (private, team, tenant, platform).
 */
export async function ShareDashboard(
  dashboard_id: string,
  data: ShareDashboardRequest,
  options?: RequestOptions
): Promise<DashboardResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/analytics/dashboards/:dashboard_id/share`;
  requestPath = requestPath.replace(':dashboard_id', encodeURIComponent(dashboard_id));
  const requestOptions = options;
  return client.post<DashboardResponse>(requestPath, data, requestOptions);
}
